import { render } from "./TransferPixDescriptionFieldContainer.vue?vue&type=template&id=121b00f8"
import script from "./TransferPixDescriptionFieldContainer.vue?vue&type=script&lang=js"
export * from "./TransferPixDescriptionFieldContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__